// src/pages/user/UserDashboard.js
import React, { useEffect, useState } from "react";
import Layout from "../../component/Layout";
import { Helmet } from "react-helmet-async";
import api from "../../axios";
import { useNavigate } from "react-router-dom";

const UserDashboard = () => {
  const [licenses, setLicenses] = useState([]);
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const sessionUser = sessionStorage.getItem("username");
    if (!sessionUser) {
      navigate("/");
      return;
    }
    setUsername(sessionUser);
    fetchLicenses(sessionUser);
  }, [navigate]);

  const fetchLicenses = async (user) => {
    try {
      const response = await api.get(`/api/license/by-username/${user}`);
      setLicenses(response.data);
    } catch (error) {
      console.error("Lisanslar getirilemedi:", error);
    }
  };
  const getStatusText = (license) => {
    const now = new Date();
  
    const start = license.startDate ? new Date(license.startDate) : null;
    const end = license.endDate ? new Date(license.endDate) : null;
  
    if (start && start > now) return "Henüz Başlamadı";
    if (end && end < now) return "Süresi Doldu";
    if (!license.isActive) return "Pasif";
  
    return "Aktif";
  };
  
  const getStatusColor = (license) => {
    const now = new Date();
  
    const start = license.startDate ? new Date(license.startDate) : null;
    const end = license.endDate ? new Date(license.endDate) : null;
  
    if (start && start > now) return "text-yellow-500";
    if (end && end < now) return "text-gray-500";
    if (!license.isActive) return "text-red-600";
  
    return "text-green-600";
  };
  

  return (
    <div>
      <Helmet>
        <title>Kullanıcı Paneli</title>
      </Helmet>
      <Layout pageTitle="Kullanıcı Paneli">
        <h2 className="text-xl font-semibold mb-4">Hoş geldiniz, {username}</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          {licenses.map((license) => (
            <div key={license.id} className="bg-white p-4 rounded shadow border">
              <h3 className="text-lg font-semibold mb-1">{license.softwareName}</h3>
              <p className="text-sm text-gray-600">Paket: {license.packageName}</p>
              <p className="text-sm text-gray-600">Lisans Anahtarı: <span className="text-xs break-all">{license.licenseKey}</span></p>
              <p className="text-sm text-gray-600">Başlangıç: {license.startDate?.substring(0,10)}</p>
              <p className="text-sm text-gray-600">Bitiş: {license.endDate?.substring(0,10)}</p>
              <p className="text-sm text-gray-600">Cihazlar: {license.activeDeviceCount} / {license.maxDeviceCount}</p>
              <p className={`text-sm font-medium ${getStatusColor(license)}`}>
                {getStatusText(license)}
              </p>
            </div>
          ))}
        </div>

        {licenses.length === 0 && (
          <p className="text-gray-500">Henüz lisans bulunmamaktadır.</p>
        )}
      </Layout>
    </div>
  );
};

export default UserDashboard;
